"use strict";
/*
    <copyright file="index.tsx" company="Top365">
    Copyright (c) Top365. All rights reserved.
    </copyright>
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var router_1 = require("./router/router");
var react_northstar_1 = require("@fluentui/react-northstar");
var resources_1 = require("./constants/resources");
var microsoftTeams = require("@microsoft/teams-js");
var constants_1 = require("./constants");
require("./App.scss");
require("./meetings.scss");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.setThemeComponent = function () {
            if (_this.state.theme === constants_1.default.dark) {
                return (React.createElement(react_northstar_1.Provider, { theme: react_northstar_1.teamsDarkTheme },
                    React.createElement("div", { className: "darkContainer" }, _this.getAppDom())));
            }
            else if (_this.state.theme === constants_1.default.contrast) {
                return (React.createElement(react_northstar_1.Provider, { theme: react_northstar_1.teamsHighContrastTheme },
                    React.createElement("div", { className: "highContrastContainer" }, _this.getAppDom())));
            }
            else {
                return (React.createElement(react_northstar_1.Provider, { theme: react_northstar_1.teamsTheme, styles: { background: 'transparent' } },
                    React.createElement("div", { className: "default-container" }, _this.getAppDom())));
            }
        };
        _this.getAppDom = function () {
            return (React.createElement("div", { className: "app-container" },
                React.createElement(router_1.AppRoute, null)));
        };
        var search = window.location.search;
        var params = new URLSearchParams(search);
        _this.theme = params.get("theme");
        _this.state = {
            theme: _this.theme ? _this.theme : resources_1.default.default,
            themeStyle: react_northstar_1.teamsTheme,
            isTeams: false,
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                microsoftTeams.initialize(function () {
                    _this.setState({
                        isTeams: true
                    });
                });
                microsoftTeams.getContext(function (context) {
                    _this.setState({ theme: context.theme });
                });
                microsoftTeams.registerOnThemeChangeHandler(function (theme) {
                    _this.setState({ theme: theme }, function () {
                        _this.forceUpdate();
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    App.prototype.render = function () {
        if (!this.state.isTeams) {
            return (React.createElement(react_northstar_1.Provider, { theme: react_northstar_1.teamsTheme, styles: { background: 'transparent' } },
                React.createElement("div", { className: "meetings" },
                    React.createElement("div", { className: "app-container" },
                        React.createElement(router_1.AppAnonymousRoute, null)))));
        }
        else {
            return (React.createElement("div", null, this.setThemeComponent()));
        }
    };
    return App;
}(React.Component));
exports.default = App;
//# sourceMappingURL=App.js.map